import { Separator, XStack, YStack } from "tamagui";
import { Title } from "./webHelpDialog.styles";
import "./styles.css";
import useBreakpoint from "@shane-collective/design-system/dist/hooks/useBreakpoint";
import { helpLinks } from "../../const";
import { Button } from "@shane-collective/design-system";

export const HelpDialog = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const breakpoint: "xxxs" | "xxs" | "xss" | "xs" | "sm" | "md" | "lg" | "xl" =
    useBreakpoint();

  return (
    <YStack
      width={
        ["xxxs", "xxs", "xss", "xs", "sm"].includes(breakpoint)
          ? "100vw"
          : "400px"
      }
      rowGap={25}
      padding={20}
      borderRadius={10}
      height={"fit-content"}
    >
      <XStack justifyContent="space-between" width="100%" alignItems="baseline">
        <XStack justifyContent="center" width={"95%"}>
          <Title textAlign="center">Help</Title>
        </XStack>

        <Button
          type={"secondary_icon"}
          backgroundColor="transparent"
          padding={0}
          borderWidth={0}
          onPress={onClose}
          aria-label={"Close settings dialog"}
          iconName="CloseIcon"
          iconWidth="15px"
        />
      </XStack>

      <Separator />

      <YStack display="flex" alignItems="flex-start" paddingLeft={10}>
          {helpLinks.map((h) => (
            <Button
              key={h.url}
              type="link"
              label={h.name}
              onPress={() => {
                window.open(h.url, "_blank");
              }}
            ></Button>
          ))}
        </YStack>

    </YStack>
  );
};
